"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _thinScrollbar = _interopRequireDefault(require("../thin-scrollbar/thin-scrollbar"));

class InfiniteThinScrollbar extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "onYReachEnd", async e => {
      const {
        scrollTop
      } = e;

      if (scrollTop === 0) {
        return;
      }

      const {
        hasMore,
        loadMore
      } = this.props;

      if (this.isLoading || !hasMore) {
        return;
      }

      this.isLoading = true;
      await loadMore();
      this.isLoading = false;
    });
  }

  render() {
    const {
      children,
      loadMore,
      className,
      containerRef
    } = this.props;
    const scrollbarProps = {};

    if (loadMore) {
      scrollbarProps.onYReachEnd = this.onYReachEnd;
    }

    return /*#__PURE__*/_react.default.createElement(_thinScrollbar.default, (0, _extends2.default)({
      className: className,
      containerRef: containerRef
    }, scrollbarProps), children);
  }

}

(0, _defineProperty2.default)(InfiniteThinScrollbar, "propTypes", {
  loadMore: _propTypes.default.func,
  hasMore: _propTypes.default.bool
});
(0, _defineProperty2.default)(InfiniteThinScrollbar, "defaultProps", {
  loadMore: null,
  hasMore: false
});
InfiniteThinScrollbar.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  containerRef: _propTypes.default.func
};
InfiniteThinScrollbar.defaultProps = {
  children: null,
  className: '',
  containerRef: null
};
var _default = InfiniteThinScrollbar;
exports.default = _default;